<template>
	<div id="onhire-add-main">
		<div class="row">
			<div class="col-sm-12">
				<div class="row mb-1">
					<div class="col-sm-7">
						<div class="d-flex align-items-center mb-2">
							<h4 class="m-0 me-4"><span v-if="id > 0">EDIT</span><span v-else>ADD</span> ON HIRE RECORD</h4>
							<a class="btn btn-outline-success btn-sm" :href="docRoot+'/onhire'">Back to list</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class=" col-md-3 col-6 text-end">
				<label for="add_onhire_company_id" class="form-label text-uppercase fw-bold py-2">Company Name <span class="mandatory">*</span></label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<select class="form-select" v-model="onhireForAdd.company_id" id="add_company_id">
						<optgroup v-if="allCompanyIdList" label="Choose Company">
							<template v-for="companyId in allCompanyIdList" :key="companyId.id">
								<option :value="companyId.id">{{ companyId.name }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div v-if="v$.onhireForAdd.company_id.$error" class="mandatory ms-3">Mandatory</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_ref_no" class="form-label text-uppercase fw-bold me-3 py-2">Ref No</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.ref_no" id="add_onhire_ref_no" placeholder="AUTOGENERATED" readonly/>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_customer_id" class="form-label text-uppercase fw-bold py-2">Customer <span class="mandatory">*</span></label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<multiselect v-model="onhireForAdd.customer_id" :options="allCustomerIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
				<div v-if="v$.onhireForAdd.customer_id.$error" class="mandatory ms-3">Mandatory</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_survey_type" class="form-label text-uppercase fw-bold py-2">Survey Type</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<select class="form-select" v-model="onhireForAdd.survey_type" id="add_survey_type">
						<optgroup v-if="allSurveyTypeList" label="Choose Survey Type">
							<template v-for="surveyType in allSurveyTypeList" :key="surveyType.id">
								<option :value="surveyType.id">{{ surveyType.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_inspection_date" class="form-label text-uppercase fw-bold me-3 py-2">Inspection Date</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<!-- <input type="text" class="form-control" v-model="onhireForAdd.inspection_date" id="add_onhire_inspection_date" placeholder="Enter Inspection Date" /> -->
					<MaskInput v-model="onhireForAdd.inspection_date" mask="##-##-####" class="form-control" textmode="uppercase" placeholder="DD-MM-YYYY"/>
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_inspection_location_id" class="form-label text-uppercase fw-bold py-2">Location</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<multiselect v-model="onhireForAdd.inspection_location_id" :options="allInspectionLocationIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_form_liquid_tanks" class="form-label text-uppercase fw-bold py-2">Form for Liquid Tanks</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<select class="form-select" v-model="onhireForAdd.form_liquid_tanks" id="add_form_liquid_tanks">
						<optgroup v-if="allFormLiquidTanksList" label="Choose Form Liquid Tanks">
							<template v-for="formLiquidTanks in allFormLiquidTanksList" :key="formLiquidTanks.id">
								<option :value="formLiquidTanks.id">{{ formLiquidTanks.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_surveyor_id" class="form-label text-uppercase fw-bold py-2">Surveyor</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<multiselect v-model="onhireForAdd.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_unit_nr" class="form-label text-uppercase fw-bold me-3 py-2">Unit Nr</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.unit_nr" id="add_onhire_unit_nr" placeholder="Enter Unit Nr" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_tank_type_id" class="form-label text-uppercase fw-bold py-2">Tank Type</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<select class="form-select" v-model="onhireForAdd.tank_type_id" id="add_tank_type_id">
						<optgroup v-if="allTankTypeIdList" label="Choose Tank Type">
							<template v-for="tankTypeId in allTankTypeIdList" :key="tankTypeId.id">
								<option :value="tankTypeId.id">{{ tankTypeId.type }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_tcode_id" class="form-label text-uppercase fw-bold py-2">Un Portable Tank</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<select class="form-select" v-model="onhireForAdd.tcode_id" id="add_tcode_id">
						<optgroup v-if="allTcodeIdList" label="Choose Tcode">
							<template v-for="tcodeId in allTcodeIdList" :key="tcodeId.id">
								<option :value="tcodeId.id">{{ tcodeId.name }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_manufacturer" class="form-label text-uppercase fw-bold me-3 py-2">Manufacturer</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.manufacturer" id="add_onhire_manufacturer" placeholder="Enter Manufacturer" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_iso_type" class="form-label text-uppercase fw-bold me-3 py-2">Iso Type</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.iso_type" id="add_onhire_iso_type" placeholder="Enter Iso Type" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_adr" class="form-label text-uppercase fw-bold me-3 py-2">ADR</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.adr" id="add_onhire_adr" placeholder="Enter Adr" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_serial_no" class="form-label text-uppercase fw-bold me-3 py-2">Serial Number</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.serial_no" id="add_onhire_serial_no" placeholder="Enter Serial No" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_first_test" class="form-label text-uppercase fw-bold py-2">First Test</label>
					</div>
					<div class="col-7">
						<input type="text" class="form-control" v-model="onhireForAdd.first_test" id="add_onhire_first_test" placeholder="Enter First Test" />
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_first_by" class="form-label text-uppercase fw-bold py-2">By</label>
					</div>
					<div class="col-7">
						<div>
							<input type="text" class="form-control" v-model="onhireForAdd.first_by" id="add_onhire_first_by" placeholder="Enter First By" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_last_25" class="form-label text-uppercase fw-bold py-2">Last 2.5 Yr</label>
					</div>
					<div class="col-7">
						<div>
							<input type="text" class="form-control" v-model="onhireForAdd.last_25" id="add_onhire_last_25" placeholder="Enter Last 25" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_last_25_by" class="form-label text-uppercase fw-bold py-2">By</label>
					</div>
					<div class="col-7">
						<div>
							<input type="text" class="form-control" v-model="onhireForAdd.last_25_by" id="add_onhire_last_25_by" placeholder="Enter Last 25 By" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_last_5" class="form-label text-uppercase fw-bold py-2">Last 5 Yr</label>
					</div>
					<div class="col-7">
						<input type="text" class="form-control" v-model="onhireForAdd.last_5" id="add_onhire_last_5" placeholder="Enter Last 5" />
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_last_5_by" class="form-label text-uppercase fw-bold py-2">By</label>
					</div>
					<div class="col-7">
						<input type="text" class="form-control" v-model="onhireForAdd.last_5_by" id="add_onhire_last_5_by" placeholder="Enter Last 5 By" />
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 p-0 text-end">
						<label for="add_onhire_next_due_date" class="form-label text-uppercase fw-bold py-2">Next Test Due</label>
					</div>
					<div class="col-7">
						<input type="text" class="form-control" v-model="onhireForAdd.next_due_date" id="add_onhire_next_due_date" placeholder="Enter Next Due Date" />
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<div class="row">
					<div class="col-5 text-end p-0">
						<label for="add_onhire_csc_acep_date" class="form-label text-uppercase fw-bold py-0">CSC ACEP / Next Csc Due</label>
					</div>
					<div class="col-7">
						<input type="text" class="form-control" v-model="onhireForAdd.csc_acep_date" id="add_onhire_csc_acep_date" placeholder="Enter Csc Acep Date" />
					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_max_gross_wgt" class="form-label text-uppercase fw-bold py-2">Maximum Gross Weight (Kg)</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="number" class="form-control" v-empty-zero v-model="onhireForAdd.max_gross_wgt" id="add_onhire_max_gross_wgt" placeholder="Enter Max Gross Wgt" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_tare_wgt" class="form-label text-uppercase fw-bold py-2">Tare (Kg)</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="number" class="form-control" v-empty-zero v-model="onhireForAdd.tare_wgt" id="add_onhire_tare_wgt" placeholder="Enter Tare Wgt" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_capacity" class="form-label text-uppercase fw-bold py-2">Capacity (L)</label>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="number" class="form-control" v-empty-zero v-model="onhireForAdd.capacity" id="add_onhire_capacity" placeholder="Enter Capacity" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_mawp" class="form-label text-uppercase fw-bold me-3 py-2">Mawp</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.mawp" id="add_onhire_mawp" placeholder="Enter Mawp" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_test_pressure" class="form-label text-uppercase fw-bold me-3 py-2">Test Pressure</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.test_pressure" id="add_onhire_test_pressure" placeholder="Enter Test Pressure" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_steam_tube_wp" class="form-label text-uppercase fw-bold me-3 py-2">Steam Tube Wp</label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.steam_tube_wp" id="add_onhire_steam_tube_wp" placeholder="Enter Steam Tube Wp" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_steam_test_pressure" class="form-label text-uppercase fw-bold me-3 py-2">Steam Test Pressure</label
				><a href="#" class="cstooltip d-none d-md-inline-block" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.steam_test_pressure" id="add_onhire_steam_test_pressure" placeholder="Enter Steam Test Pressure" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_shell_tank_material" class="form-label text-uppercase fw-bold me-3 py-2">Shell Tank Material</label
				><a href="#" class="cstooltip d-none d-md-inline-block" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.shell_tank_material" id="add_onhire_shell_tank_material" placeholder="Enter Shell Tank Material" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_shell_head" class="form-label text-uppercase fw-bold me-3 py-2">Shell Head</label
				><a href="#" class="cstooltip d-none d-md-inline-block" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.shell_head" id="add_onhire_shell_head" placeholder="Enter Shell Head" />
				</div>
			</div>
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_shell_thickness" class="form-label text-uppercase fw-bold me-3 py-2">Shell Thickness (Mm)</label
				><a href="#" class="cstooltip d-none d-md-inline-block" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.shell_thickness" id="add_onhire_shell_thickness" placeholder="Enter Shell Thickness" />
				</div>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-md-3 col-6 text-end">
				<label for="add_onhire_shell_head_thickness" class="form-label text-uppercase fw-bold me-3 py-2">Shell Head Thickness (Mm)</label
				><a href="#" class="cstooltip d-none d-md-inline-block" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-6">
				<div>
					<input type="text" class="form-control" v-model="onhireForAdd.shell_head_thickness" id="add_onhire_shell_head_thickness" placeholder="Enter Shell Head Thickness" />
				</div>
			</div>
		</div>
		<!-- Child 1 -->
		<onhiremain-add-component :main-object="mainObject" v-model="onhireForAdd.main"></onhiremain-add-component>
		<!-- Child 1 -->
		<!-- Child 2 -->
		<onhireancillary-add-component :main-object="ancillaryObject" v-model="onhireForAdd.ancillary"></onhireancillary-add-component>
		<!-- Child 2 -->
		<!-- Child 3 -->
		<onhireunitnr-add-component :main-object="unitnrObject" v-model="onhireForAdd.unitnr"></onhireunitnr-add-component>
		<!-- Child 3 -->
		<!-- Walkway image 1 -->
		<div class="row mb-4">
			<div class="col-md-2 text-md-end px-1">
				<label for="add_company_name" class="form-label text-uppercase fw-bold me-3">Upload Walkway Image 1</label>
			</div>
			<div class="col-md-7">
				<div class="d-flex flex-row gap-3">
					<!-- <template v-if="onhireForAdd.id && onhireForAdd.id > 0">
					</template> -->
					<div class="mb-2" v-if="onhireForAdd.walkway_image_1 && onhireForAdd.walkway_image_1.length > 5">
						<img :src="docRoot+'/onhire/view-file/1/' + onhireForAdd.id +'/'+imageId" style="max-width: 100px" />
						<p class="my-2 p-0"><a href="javascript:void(0)" class="text-danger" @click="clearImage(1)">Clear image</a></p>
					</div>
					<template v-else>
						<div>
							<input type="file" id="walkway_1_url" ref="walkway_1_url" @change="prepareUpload($event, 1)" accept="image/*" />
							<div class="d-flex flex-row gap-3 align-items-center mb-2">
								<label for="walkway_1_url" class="bg-dark p-2 text-white rounded-2">
									<span v-if="document1.file_name">Upload new image</span>
									<span v-else>Upload image</span>
								</label>
								<button typ="button" class="btn btn-outline-danger" v-if="document1.contents && document1.contents.length > 0" @click="cancelUpload(1)">Clear</button>
							</div>
							<p class="text-dark mb-0"><small>Maximum upload size is 2MB. Supported format is JPG, JPEG and PNG only.</small></p>
							<p class="text-dark mb-0"><small>Please ensure that the dimensions are correct.</small></p>
						</div>
					</template>
				</div>
			</div>
			<div class="col-md-3" v-if="document1.contents && document1.contents.length > 0">
				<img :src="document1.contents" class="img-fluid" style="max-height: 100px;">
			</div>
		</div>
		<!-- Walkway image 1 -->
		<!-- Walkway image 2 -->
		<div class="row mb-4">
			<div class="col-md-2 text-md-end px-1">
				<label for="add_company_name" class="form-label text-uppercase fw-bold me-3">Upload Walkway Image 2</label>
			</div>
			<div class="col-md-7">
				<div class="d-flex flex-row gap-3">
					<!-- <template v-if="onhireForAdd.id && onhireForAdd.id > 0"> -->
						<!-- </template> -->
					<div class="mb-2" v-if="onhireForAdd.walkway_image_2 && onhireForAdd.walkway_image_2.length > 5">
						<img :src="docRoot+'/onhire/view-file/2/' + onhireForAdd.id +'/'+imageId" style="max-width: 100px" />
						<p class="my-2 p-0"><a href="javascript:void(0)" class="text-danger" @click="clearImage(2)">Clear image</a></p>
					</div>
					<template v-else>
						<div>
							<input type="file" id="walkway_2_url" ref="walkway_2_url" @change="prepareUpload($event, 2)" accept="image/*" />
							<div class="d-flex flex-row gap-3 align-items-center mb-2">
								<label for="walkway_2_url" class="bg-dark p-2 text-white rounded-2">
									<span v-if="document1.file_name">Upload new image</span>
									<span v-else>Upload image</span>
								</label>
								<button typ="button" class="btn btn-outline-danger" v-if="document2.contents && document2.contents.length > 0" @click="cancelUpload(2)">Clear</button>
							</div>
							<p class="text-dark mb-0"><small>Maximum upload size is 2MB. Supported format is JPG, JPEG and PNG only.</small></p>
							<p class="text-dark mb-0"><small>Please ensure that the dimensions are correct.</small></p>
						</div>
					</template>
				</div>
			</div>
			<div class="col-md-3" v-if="document2.contents && document2.contents.length > 0">
				<img :src="document2.contents" class="img-fluid" style="max-height: 100px;">
			</div>
		</div>
		<!-- Walkway image 2 -->
		<div class="row mb-4">
			<div class="col-md-6">
				<label for="add_onhire_comment_1" class="form-label text-uppercase fw-bold m-0 py-2">Comment 1</label>
				<div>
					<textarea class="form-control" v-model="onhireForAdd.comment_1" id="add_onhire_comment_1" placeholder="Enter Comment 1"></textarea>
				</div>
			</div>
			<div class="col-md-6">
				<label for="add_onhire_comment_2" class="form-label text-uppercase fw-bold m-0 py-2">Comment 2</label>
				<div>
					<textarea class="form-control" v-model="onhireForAdd.comment_2" id="add_onhire_comment_2" placeholder="Enter Comment 2"></textarea>
				</div>
			</div>
		</div>
		<div class="row mb-5">
			<div class="col-md-3">
				<button type="button" class="btn btn-dark btn-sm w-100" @click="saveOnhire()">SAVE CHANGES</button>
			</div>
		</div>
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required} from "@vuelidate/validators";
	function initialState() {
		return {
			id: 0,
			company_id: null,
			ref_no: "",
			customer_id: null,
			survey_type: null,
			inspection_date: "",
			inspection_location_id: null,
			form_liquid_tanks: null,
			surveyor_id: null,
			unit_nr: "",
			tank_type_id: null,
			tcode_id: null,
			manufacturer: "",
			iso_type: "",
			adr: "",
			serial_no: "",
			first_test: "",
			first_by: "",
			last_25: "",
			last_25_by: "",
			last_5: "",
			last_5_by: "",
			next_due_date: "",
			csc_acep_date: "",
			max_gross_wgt: 0,
			tare_wgt: 0,
			capacity: 0,
			mawp: "",
			test_pressure: "",
			steam_tube_wp: "",
			steam_test_pressure: "",
			shell_tank_material: "",
			shell_head: "",
			shell_thickness: "",
			shell_head_thickness: "",
			walkway_image_1: null,
			walkway_image_2: null,
			comment_1: "",
			comment_2: "",
			main: {},
			ancillary: {},
			unitnr: {},
			action: ""
		};
	}
	function initialStateValidations() {
		return {
			company_id: {required},
			customer_id: {required},
		};
	}
	export default {
		name: "Onhiremaster",
		props: ["current_user_id", "all_permissions", "id","param1"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				dataprops: {
					id: "onhire-list",
					class: "a",
					base_url: "/api/onhire/",
					columns: [
						{title: "Company", property: "company.name", alt_value: "Not Specified"},
						{title: "Ref No", property: "ref_no"},
						{title: "Customer", property: "customer.name", alt_value: "Not Specified"},
						{title: "Inspection Date", property: "inspection_date"},
						{title: "Inspection Location", property: "inspection_location.title", alt_value: "Not Specified"},
						{title: "Surveyor", property: "surveyor.name", alt_value: "Not Specified"},
						{title: "Tank Type", property: "tank_type.title", alt_value: "Not Specified"},
						{title: "Created By", property: "creator.name", alt_value: "Not Specified"}
					],
					data_to_send: {current_user_id: this.current_user_id},
					reload: false,
					search: "simple"
				},
				addEditModal: null,
				readModal: null,
				currentUser: siteUserObject,
				onhireForAdd: initialState(),
				mainObject: {},
				ancillaryObject: {},
				unitnrObject: {},
				document1: {
					uploaded_file: null,
					contents: null,
					file_name: ""
				},
				document2: {
					uploaded_file: null,
					contents: null,
					file_name: ""
				},
				imageId: 0,
				readOnhire: {},
				allCompanyIdList: [],
				allCustomerIdList: [],
				allSurveyTypeList: [],
				allInspectionLocationIdList: [],
				allFormLiquidTanksList: [],
				allSurveyorIdList: [],
				allTankTypeIdList: [],
				allTcodeIdList: []
			};
		},
		validations() {
			return {
				onhireForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.onhireForAdd = initialState();
				this.v$.$reset();
			},
			async saveOnhire(event) {
				var that = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				if ( that.onhireForAdd.surveyor_id != 'null' && typeof that.onhireForAdd.surveyor_id === 'object' && that.onhireForAdd.surveyor_id.id) {
					that.onhireForAdd.surveyor_id = that.onhireForAdd.surveyor_id.id;
				}
				if ( that.onhireForAdd.customer_id != 'null' && typeof that.onhireForAdd.customer_id === 'object' && that.onhireForAdd.customer_id.id) {
					that.onhireForAdd.customer_id = that.onhireForAdd.customer_id.id;
				}
				if ( that.onhireForAdd.inspection_location_id != 'null' && typeof that.onhireForAdd.inspection_location_id === 'object' && that.onhireForAdd.inspection_location_id.id) {
					that.onhireForAdd.inspection_location_id = that.onhireForAdd.inspection_location_id.id;
				}
				if (!this.onhireForAdd.action || this.onhireForAdd.action == "") this.onhireForAdd.action = "details";
				this.onhireForAdd.created_by = this.current_user_id;
				console.log(this.onhireForAdd);
				// return;
				this.showLoading("Saving ...");
				axios
					.post(this.docRoot+"/onhire/save", {onhire: this.onhireForAdd})
					.then(async function (response) {
						that.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							// Set the ID so that duplicate records will not be created
							that.onhireForAdd.id = response.data.id;
							if ((that.document1.uploaded_file == null || that.document1.uploaded_file == undefined) && 
							(that.document2.uploaded_file == null || that.document2.uploaded_file == undefined) ) {
								that.showToast("On Hire Record saved successfully", "success", "bottom", 3000);
								// that.reloadEverything();
								if(that.param1 === "mobileapp") {
									window.location = that.docRoot + "/operation-successful/";
									that.showLoading("Loading ...");
								}else{
									setTimeout(() => {
										window.location = that.docRoot + "/onhire/";
										that.showLoading("Loading ...");
									}, 1500);
								}
							}
							else {
								// this means that the file has been uploaded
								// Try to handle the upload
								that.handleUpload(response.data.id);
							}
						} else that.showErrors("On Hire record could not be saved successfully", response.data.messages, "bottom", 3000);
					})
					.catch(function (error) {
						console.log(error);
						that.closeSwal();
						that.showToast("On Hire could not be saved successfully", "error", "bottom", 3000);
					});
			},
			prepareEditOnhire(onhire) {
				this.onhireForAdd = Object.assign({}, onhire);
				this.addEditModal.show();
			},
			async prepareUpload(event, which) {
				let file = event.target.files[0];
				if (file.type != "image/jpg" && file.type != "image/jpeg" && file.type != "image/png") {
					this.showToast("You can only upload JPG, JPEG and PNG images", "error", "bottom", 3000);
					return;
				}
				if (file.size > 2 * 1024 * 1024) {
					try {
						this.showToast("Compressing image...", "info", "bottom", 2000);
						const originalSize = (file.size / 1024 / 1024).toFixed(2);
						file = await this.compressImage(file, 1);
						const compressedSize = (file.size / 1024 / 1024).toFixed(2);
						this.showToast(`Image compressed from ${originalSize}MB to ${compressedSize}MB`, "success", "bottom", 2000);
					} catch (error) {
						console.error("Compression error:", error);
						this.showToast("Failed to compress image", "error", "bottom", 3000);
						return;
					}
				}
				if (which == 1) {
					this.document1.uploaded_file = file;
					this.document1.file_name = this.document1.uploaded_file.name;
				}
				else if (which == 2) {
					this.document2.uploaded_file = file;
					this.document2.file_name = this.document2.uploaded_file.name;
				}
				const reader = new FileReader();
				reader.onload = ((e) => {
					if (which == 1) {
						this.document1.contents = e.target.result;
					}
					else if (which == 2) {
						this.document2.contents = e.target.result;
					}
				});
				reader.readAsDataURL(file);
			},
			cancelUpload(which) {
				if (which == 1) {
					this.document1 = {
						uploaded_file: null,
						contents: null,
						file_name: ""
					};
				}
				else if (which == 2) {
					this.document2 = {
						uploaded_file: null,
						contents: null,
						file_name: ""
					};
				}
			},
			handleUpload(id) {
				let that = this;
				const formData = new FormData();
				formData.append("onhire_id", id);
				if( this.document1.uploaded_file )
					formData.append("uploaded_file_1", this.document1.uploaded_file);
				if( this.document2.uploaded_file )
					formData.append("uploaded_file_2", this.document2.uploaded_file);
				// Send the data
				let URL = this.docRoot + "/onhire/upload-file";
				this.showLoading("Saving ...");
				axios
					.post(URL, formData, {
						headers: {
							"Content-Type": "multipart/form-data"
						}
					})
					.then(function (response) {
						console.log(response);
						that.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							that.showToast("On Hire Record saved successfully", "success", "bottom", 3000);
							// that.reloadEverything();
							that.imageId = Math.round(Math.random() * 100);
							setTimeout(() => {
								window.location = that.docRoot + "/onhire/";
								that.showLoading("Loading ...");
							}, 1500);
						}
						else {
							that.showErrors("On Hire Record has been saved but the File could not be uploaded successfully", response.data.messages, "bottom", 5000);
						}
						return status;
					})
					.catch(function (error) {
						console.log(error);
						that.closeSwal();
						that.showToast("On Hire Record has been saved but the File could not be uploaded successfully", "error", "bottom", 3000);
						return -1;
					});
			},
			clearImage(purpose) {
				let that = this;
				let URL = this.docRoot + "/onhire/clear-file/" + purpose + "/" + this.onhireForAdd.id + "/123";
				this.showConfirm("Do you really want to delete the file?", "Yes", "No").then((result) => {
					if (result.isConfirmed) {
						this.showLoading("Clearing file ...");
						axios
							.post(URL, {}, {
								headers: {
									"Content-Type": "multipart/form-data"
								}
							})
							.then(function (response) {
								that.closeSwal();
								var status = response.data.status;
								console.log(response);
								
								if (status == 1) {
									that.showToast("File cleared successfully", "success", "bottom", 3000);
									if (purpose == 1) {
										that.document1 = {
											uploaded_file: null,
											contents: null,
											file_name: ""
										};
										that.onhireForAdd.walkway_image_1 = null;
									}
									else if (purpose == 2) {
										that.document2 = {
											uploaded_file: null,
											contents: null,
											file_name: ""
										};
										that.onhireForAdd.walkway_image_2 = null;
									}
								}
								else {
									that.showErrors("File could not be cleared successfully", response.data.messages, "bottom", 5000);
								}
								return status;
							})
							.catch(function (error) {
								console.log(error);
								that.closeSwal();
								that.showToast("File could not be cleared successfully", "error", "bottom", 3000);
								return -1;
							});
					}
				});
			},
			toggleOnhire(onhire, status) {
				var that = this;
				Swal.fire({
					icon: "question",
					html: "Do you really want to " + (status == 1 ? "reactivate" : "deactivate") + ' the On Hire - <br/>"' + onhire.ref_no + '"?',
					showCancelButton: true
				}).then((result) => {
					if (result.isConfirmed) {
						that.onhireForAdd = onhire;
						that.onhireForAdd.status = status;
						that.onhireForAdd.action = "status";
						that.saveOnhire();
					}
				});
			},
			reloadEverything() {
				if (this.id !== undefined && !isNaN(this.id)) {
					this.mode = "edit";
					this.cancelUpload(1);
					this.cancelUpload(2);
					// This is Edit mode - fetch inquiry data
					var that = this;
					var URL = this.docRoot + "/api/onhire/get-record/" + this.id;
					this.showLoading("Loading ...");
					axios
						.post(URL, {})
						.then(function (response) {
							that.closeSwal();
							that.onhireForAdd = Object.assign({}, response.data);
							if( that.onhireForAdd.main ){
								that.mainObject = that.onhireForAdd.main;
								that.mainObject.refresh = true;
							}
							if( that.onhireForAdd.ancillary ){
								that.ancillaryObject = that.onhireForAdd.ancillary;
								that.ancillaryObject.refresh = true;
							}
							if( that.onhireForAdd.unitnr ){
								that.unitnrObject = that.onhireForAdd.unitnr;
								that.unitnrObject.refresh = true;
							}
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			if (this.id > 0){
				this.reloadEverything();
			}
			else {
				this.mainObject.refresh = true;
				this.ancillaryObject.refresh = true;
				this.unitnrObject.refresh = true;
			}
			this.allCompanyIdList = await this.loadAllCompany(true);
			// this.allCustomerIdList = await this.loadAllCustomer(true);

			let _allSurveyorIdList = await this.loadAllSurveyor(true);
			if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
				this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allCustomerIdList = await this.loadAllCustomer(true);
			if(Array.isArray(_allCustomerIdList) && _allCustomerIdList.length > 0){
				this.allCustomerIdList = _allCustomerIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allInspectionLocationIdList = await this.loadAllInspectionLocation(true);
			if(Array.isArray(_allInspectionLocationIdList) && _allInspectionLocationIdList.length > 0){
				this.allInspectionLocationIdList = _allInspectionLocationIdList.map(x => {return { id: x.id, text: x.name }});
			}
			this.allSurveyTypeList = [
				{id: "1", title: "On-Hire"},
				{id: "2", title: "Off-Hire"},
				{id: "3", title: "Condition"}
			];
			// this.allInspectionLocationIdList = await this.loadAllInspectionLocation(true);
			this.allFormLiquidTanksList = [
				{id: "1", title: "Food"},
				{id: "2", title: "Chemicals"}
			];
			// this.allSurveyorIdList = await this.loadAllSurveyor(true);
			this.allTankTypeIdList = await this.loadAllTankType(true);
			this.allTcodeIdList = await this.loadAllTcode(true);
			this.imageId = Math.round(Math.random() * 100);
			if (this.onhireForAdd.surveyor_id) {
				if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
					let _allRelationList = this.allSurveyorIdList;
					let relationId = parseInt(this.onhireForAdd.surveyor_id);
					this.onhireForAdd.surveyor_id = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.onhireForAdd.customer_id) {
				if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
					let _allRelationList = this.allCustomerIdList;
					let relationId = parseInt(this.onhireForAdd.customer_id);
					this.onhireForAdd.customer_id = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.onhireForAdd.inspection_location_id) {
				if (Array.isArray(this.allInspectionLocationIdList) && this.allInspectionLocationIdList.length > 0) {
					let _allRelationList = this.allInspectionLocationIdList;
					let relationId = parseInt(this.onhireForAdd.inspection_location_id);
					this.onhireForAdd.inspection_location_id = _allRelationList.find(item => item.id === relationId);
				}
			}
		}
	};
</script>
